import { GameCardDataProps } from 'src/components/GameCard/GameCard';

export function interleaveGameAndDealOffers(
  games: GameCardDataProps[],
  deals: GameCardDataProps[]
): GameCardDataProps[] {
  const offers: GameCardDataProps[] = [];
  const maxOfferCount = Math.max(games.length, deals.length);

  for (let index = 0; index < maxOfferCount; index += 1) {
    if (games[index]) {
      offers.push(games[index]);
    }

    if (deals[index]) {
      offers.push(deals[index]);
    }
  }

  return offers;
}

export function sortOffersByPointsDescending(offers: readonly GameCardDataProps[]): GameCardDataProps[] {
  return [...offers].sort((left, right) => right.points - left.points);
}
